import { render, staticRenderFns } from "./ModalSurvey.vue?vue&type=template&id=6f1a44f5&scoped=true&lang=pug&"
import script from "./ModalSurvey.vue?vue&type=script&lang=js&"
export * from "./ModalSurvey.vue?vue&type=script&lang=js&"
import style0 from "./ModalSurvey.vue?vue&type=style&index=0&id=6f1a44f5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1a44f5",
  null
  
)

export default component.exports